import React, { Component } from 'react';
import { IconButton, PrimaryButton, Toggle, Icon } from 'office-ui-fabric-react';

class ChartInstructions extends Component {
  state = {
    legend: true,
    datum: false,
    axis: false,
    multi_year: 2000,
    stat_year: 2010,
    start: 1931,
    end: 2012,
  }

  render(){
    return (
      <div>
        <div className='instruction-content'>
          <p>Charts allows you 3 different ways to analyze data.</p>
          <ul>
            <li><strong>Multiple Alternative</strong>: This option displays data for all available alternatives on one chart to compare over a calendar year. Jump from year to year and visualize the actual data, or select a single statistic.</li>
            <li><strong>Single Alternative</strong>: Charts actual and statistical data for a single alternative over a year. Jump from year to year to see how the annual data varies relative to historical variation.</li>
            <li><strong>Time Series</strong>: Charts data for all alternatives over a continuous range of years.</li>
          </ul>
        </div>
    
        <div className='instruction-section'>
          <h3>Filters</h3>
          <div className='instruction-content'>
            <p>By default, the locations available are filtered to only display "Favorite" locations which are pre-defined or added manually by you</p>
            <div className='flex align-center'>Use the dropdown menu's to pupolate all fields, then click  <PrimaryButton style={{margin: '0px 5px'}}>Apply</PrimaryButton> to load the data.</div>
            <hr></hr>
            <p>Additional Tools:</p>
            <div className='flex align-center' style={{marginBottom: '4px'}}><div style={{ margin: '0px 5px', border: '1px solid #c9c9c9' }}><IconButton iconProps={{iconName: 'FavoriteStarFill', style: {color: 'rgb(0, 120, 212)'}}}/></div> Toggle between favorites and comprehensive view (see below).</div>
            <div className='flex align-center' style={{marginBottom: '4px'}}><div style={{ margin: '0px 5px', border: '1px solid #c9c9c9' }}><IconButton iconProps={{iconName: 'EraseTool'}}/></div> button to clear the applied filters and data for this chart.</div>
            <div className='flex align-center' style={{marginBottom: '4px'}}><div style={{ margin: '0px 5px', border: '1px solid #c9c9c9' }}><IconButton iconProps={{iconName: 'Copy'}}/></div> button to copy filters applied on the current chart.</div>
            <div className='flex align-center' style={{marginBottom: '4px'}}><div style={{ margin: '0px 5px', border: '1px solid #c9c9c9' }}><IconButton iconProps={{iconName: 'Paste'}}/></div> button to paste copied filters to the current chart.</div>
          </div>
        </div>
    
        {/* <div className='instruction-section'>
          <h3>Line Styles</h3>
          <div className='instruction-content'>
            <p>Under the line styles tab, you will see every line that is chartable. Each line has a circle button that toggles it's visiblity. Click on the pencil to edit the lines style.</p>
            <div style={{padding: '4px', marginBottom: '4px', border: '1px solid #c9c9c9', display: 'flex', width: '200px', justifyContent: 'space-between'}}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <IconButton iconProps={{iconName: 'CircleFill', style: {color: 'orange'}}}/>
                <span>NO ACTION</span>
              </div>
              <IconButton iconProps={{iconName: 'Edit'}}/>
            </div>
            <div style={{padding: '4px', marginBottom: '4px', border: '1px solid #c9c9c9', display: 'flex', width: '200px', justifyContent: 'space-between'}}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <IconButton iconProps={{iconName: 'CircleAdditionSolid', style: {color: '#c9c9c9'}}}/>
                <span>ALT 1</span>
              </div>
              <IconButton iconProps={{iconName: 'Edit'}}/>
            </div>
            <div style={{padding: '4px', border: '1px solid #c9c9c9', display: 'flex', width: '200px', justifyContent: 'space-between'}}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <IconButton iconProps={{iconName: 'CircleAdditionSolid', style: {color: '#c9c9c9'}}}/>
                <span>ALT 2</span>
              </div>
              <IconButton iconProps={{iconName: 'Edit'}}/>
            </div>
          </div>
        </div> */}

        <div className='instruction-section'>
          <h3>Favorites vs Comprehensive Views</h3>
          <div className='instruction-content'>
            <div className='flex-align-top'>
              <div style={{marginRight: '10px'}}>
                <p>
                  When the star icon is filled, you will see a shortened list of <strong>favorite</strong> locations. These locations have been either saved by you, or are identified as key locations.
                  These locations can represent both RESSIM and HECRAS locations. Selecting a location will automatically select the source, river and location.
                </p>
              </div>
              <img src='../../../images/filters_fav.png' alt='Filter Favorites' width="300px"/>
            </div>
            <div className='flex-align-top'>
              <div style={{marginRight: '10px'}}>
                <p>
                  When the star icon is not filled, you will see a <strong>comprehensive</strong> list of every 
                  possible location. Two additional dropdown 
                  menus will allow you to select the source, river, and location individually.
                </p>
              </div>
              <img src='../../../images/filters_nonfav.png' alt='Comprehensive Views' width="300px"/>
            </div>
            <p>
              HEC-RESSIM (usually referred to just as RESSIM) is a reservoir operations model developed by the USACE HEC. 
              The model incorporates user defined rules with other conditions (i.e., inflow, pool elevation, and downstream flows) to determine reservoir outflow. 
              Use the RESSIM dropdown to access <strong>reservoir, powerhouse</strong> and <strong>system storage</strong> information.
            </p>
            <p>
              HEC-RAS is designed to perform one-dimensional hydraulic calculations for natural and constructed channels. 
              Outputs displayed in HydroViz include <strong>stage</strong> and <strong>flow</strong> for many thousands of cross-sections north of Gavins Point.
            </p>
          </div>
        </div>

        <div className='instruction-section'>
          <h3>Thresholds</h3>
          <div className='instruction-content'>
            <p>Use thresholds to manually add lines to charts. They can help visually distinguish important points on the chart.</p>
            <div className='flex align-center'><IconButton iconProps={{iconName: 'Edit'}} /> Edit the threshold settings such as line style, color, width, and value.</div>
            <div className='flex align-center'><IconButton iconProps={{iconName: 'Save'}} /> Save the threshold to the current location. It will automatically load anytime you access the location it's saved to.</div>
          </div>
        </div>

        <div className='instruction-section'>
          <h3>Chart Controls</h3>
          <div className='instruction-content'>
            <p>Toggle the visibility of the chart legend. The legend is always visible by default.</p>
            <p>Several locations have a datum available which convers the values to easier to recognize number. If available, you will be given the option to adjust values to the datum.</p>
            <p>You can optionally lock the y axis to prevent the chart from changing scale vertically.</p>
            <div className='controls'>
              <div className='flex-col'>
                <span>Display Legend:</span>
                <Toggle checked={this.state.legend} onChange={(e, legend) => this.setState({legend})}/>
              </div>
              <div className='flex-col'>
                <span>Adjsut to Datum:</span>
                <Toggle checked={this.state.datum} onChange={(e, datum) => this.setState({datum})}/>
              </div>
              <div className='flex-col'>
                <span>Lock Y Axis:</span>
                <Toggle checked={this.state.axis} onChange={(e, axis) => this.setState({axis})}/>
              </div>
            </div>
          </div>
        </div>
        
        <div className='instruction-section'>
          <h3>Multiple Alternative</h3>
          <div className='instruction-content'>
            <div className='flex-align-top'>
              <div style={{marginRight: '10px'}}>
                <p>Use the filters panel to select a location, and type, then click Apply.</p>
              </div>
              <img src='../../../images/multi_alt_filters.png' alt='Time Series Filters' width="300px"/>
            </div>
            <p>
              Once you have loaded data you will see a chart with each alternative’s performance, as well as any stage data and thresholds according to the National Weather Service that are associated with the location. (Only the NWS gage locations have stage / threshold data).
            </p>
            <img src='../../../images/multi_alt_chart.png' alt='Stat Selector' width="100%"/>
            <p>Additional controls are available to modify the data that is displayed on the chart.</p>
            <div className='flex-align-top'>
              <img src='../../../images/multi_alt_alts.png' alt='Alternative Selector' width="180px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Click the checkboxes to add or remove lines from the chart.
                </p>
              </div>
              <img src='../../../images/multi_alt_radio.png' alt='Stat Selector' width="180px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Use the radio buttons to select which stat you would like to see on the chart.
                </p>
              </div>
            </div>
            <div className='flex-align-top'>
              <img src='../../../images/multi_alt_pick_year.png' alt='Alternative Selector' width="180px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  If you choose "Pick Year", an additional field will appear which allows you to change the year that's displayed.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className='instruction-section'>
          <h3>Single Alternative</h3>
          <div className='instruction-content'>
            <div className='flex-align-top'>
              <div style={{marginRight: '10px'}}>
                <p>Use the filters panel to select a location, type, alternative, and year then click Apply.</p>
              </div>
              <img src='../../../images/single_alt_filters.png' alt='Single Alternative Filters' width="300px"/>
            </div>
            <p>This chart will display one year of data, from January 1 - December 31. By default, the chart will display the following data:</p>
            <ul>
              <li>Minimum and Maximum <Icon iconName="LocationFill" style={{color: '#d3d3d3'}}/></li>
              <li>90th and 10th percentile <Icon iconName="LocationFill" style={{color: '#999999'}}/></li>
              <li>Average <Icon iconName="LocationFill" style={{color: '#66FF00'}}/></li>
              <li>50th percentile <Icon iconName="LocationFill" style={{color: '#ffa500'}}/></li>
              <li>Actual <Icon iconName="LocationFill" style={{color: '#44c3ff'}}/></li>
            </ul>
            <img src='../../../images/stats_example.png' alt='Stat Chart' width="100%"/>
          </div>
        </div>


        <div className='instruction-section'>
          <h3>Time Series</h3>
          <div className='instruction-content'>
            <div className='flex-align-top'>
              <div style={{marginRight: '10px'}}>
                <p>Use the filters panel to select a location, type, and range of years, then click Apply.</p>
                <p>Larger date ranges will pick a subset of data to enhance performace. For example, When you select over 50 years only the first and 15th day of each month will be plotted.</p>
              </div>
              <img src='../../../images/time_series_filters.png' alt='Time Series Filters' width="300px"/>
            </div>
            <img src='../../../images/time_series_example.png' alt='Time Series Chart' width="100%"/>
            {/* <p>optionally include stats using the stat selector. <em>Including stats will slow down load times for larger date ranges.</em></p> */}
          </div>
        </div>

        <div className='instruction-section'>
          <h3>Plot Tools</h3>
          <div className='instruction-content'>
            <div className='flex-align-top'>
              <img src='../../../images/chart-zoom-to.png' alt='Zoom Chart' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Zoom in on a section of the chart
                </p>
              </div>
              <img src='../../../images/chart-pan.png' alt='Pan Chart' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Pan around the chart area
                </p>
              </div>
            </div>

            <div className='flex-align-top'>
              <img src='../../../images/chart-zoom-in.png' alt='Zoom Chart In' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Zoom in on the chart
                </p>
              </div>
              <img src='../../../images/chart-zoom-out.png' alt='Zoom Chart Out' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Zoom out on the chart
                </p>
              </div>
            </div>

            <div className='flex-align-top'>
              <img src='../../../images/chart-autoscale.png' alt='Chart Auto Scale' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Auto scale axis on chart
                </p>
              </div>
              <img src='../../../images/chart-reset-axis.png' alt='Reset Axis' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Reset the axis on chart
                </p>
              </div>
            </div>

            <div className='flex-align-top'>
              <img src='../../../images/chart-spike-line.png' alt='Toggle Spike Lines' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Toggle spike lines
                </p>
              </div>
              <img src='../../../images/chart-closest.png' alt='Closest Hover' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Show closest label on hover
                </p>
              </div>
            </div>

            <div className='flex-align-top'>
              <img src='../../../images/chart-all-labels.png' alt='All Hover' width="100px"/>
              <div style={{marginLeft: '10px', flex: 1}}>
                <p>
                  Show all labels on hover
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ChartInstructions


// WEBPACK FOOTER //
// ./src/components/instructions/ChartInstructions.js